import React, { forwardRef } from 'react';

type Props = {
  renderHiddenContent?: boolean;
  id?: string | number | boolean;
  selectedId?: string | number | boolean;
  component?: React.ElementType;
};

// replace index to id
const TabContent = forwardRef<HTMLElement, Props>(
  (
    {
      renderHiddenContent = true,
      id = undefined,
      selectedId = undefined,
      component = 'div',
      ...tabContentProps
    }: Props,
    ref,
  ) => {
    const RenderComponent = component;

    return (
      (!!renderHiddenContent || id === selectedId) && (
        <RenderComponent
          {...tabContentProps}
          aria-labelledby={`tab-${id}`}
          ref={ref}
          style={{
            display: id !== selectedId ? 'none' : null,
          }}
        />
      )
    );
  },
);

TabContent.displayName = 'TabContent';

export default TabContent;
